const getSnapInterval = (width: number, gap: number, amount: number) => {
  return (width - gap * (amount - 1)) / amount
}

export default getSnapInterval
